import { axiosAjax } from '@app/src/config/axios';
import { BrandVehicleModel } from '@app/src/views/StepOne/form/models/brandVehicle';
import { hydrateData } from './hydrators';

export const brandVehicleService = {
  async get(vehicleId: number, brandName: string, flag?: string): Promise<BrandVehicleModel[]> {
    try {
      let uri = process.env.API_VEHICLE_BRAND
                .replace(':vehicleId', '' + vehicleId)
                .replace(':brandName', brandName);
      if (flag === 'all') {
        uri = process.env.API_VEHICLE_BRAND_ALL
                .replace(':brandName', brandName);
      }
      const { data } = await axiosAjax.get(uri);
      if (data.error) {
        throw new Error();
      }
      return hydrateData(data.data);
    } catch (e) {
      throw new Error(e);
    }
  }
}
